var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SellerPerformanceParams_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { SolutionType } from '../solutionType';
import { SolutionParams } from './solutionParams';
import { sellerPerformanceParamsSchemaValidation } from '../../validations.generated';
export var SellerPerformanceParamNames;
(function (SellerPerformanceParamNames) {
    SellerPerformanceParamNames["DataSourceID"] = "dataSourceID";
    SellerPerformanceParamNames["SellerIdColumn"] = "sellerIdColumn";
    SellerPerformanceParamNames["SellerNameColumn"] = "sellerNameColumn";
    SellerPerformanceParamNames["AttainmentColumn"] = "attainmentColumn";
    SellerPerformanceParamNames["AvgDealSizeColumn"] = "avgDealSizeColumn";
    SellerPerformanceParamNames["WinRateColumn"] = "winRateColumn";
    SellerPerformanceParamNames["RevenueColumn"] = "revenueColumn";
    SellerPerformanceParamNames["VariablePayRatioColumn"] = "variablePayRatioColumn";
})(SellerPerformanceParamNames || (SellerPerformanceParamNames = {}));
export const sellerPerformanceParamsSchema = {
    $id: 'urn:wisepipe-solution-domain:SellerPerformanceParams',
    type: 'object',
    properties: {
        sellerIdColumn: { type: 'string', minLength: 1 },
        sellerNameColumn: { type: 'string', minLength: 1 },
        attainmentColumn: { type: 'string', minLength: 1 },
        avgDealSizeColumn: { type: 'string', minLength: 1 },
        winRateColumn: { type: 'string', minLength: 1 },
        revenueColumn: { type: 'string', minLength: 1 },
        variablePayRatioColumn: { type: 'string', minLength: 1 }
    },
    required: []
};
let SellerPerformanceParams = SellerPerformanceParams_1 = class SellerPerformanceParams extends SolutionParams {
    constructor(sellerIdColumn, sellerNameColumn, attainmentColumn, avgDealSizeColumn, winRateColumn, revenueColumn, variablePayRatioColumn) {
        super(SolutionType.SellerPerformance);
        this.sellerIdColumn = sellerIdColumn;
        this.sellerNameColumn = sellerNameColumn;
        this.attainmentColumn = attainmentColumn;
        this.avgDealSizeColumn = avgDealSizeColumn;
        this.winRateColumn = winRateColumn;
        this.revenueColumn = revenueColumn;
        this.variablePayRatioColumn = variablePayRatioColumn;
        JSON.validate(this, SellerPerformanceParams_1);
    }
    toTemplateParams(dataSource) {
        if (!this.sellerIdColumn ||
            !this.sellerNameColumn ||
            !this.attainmentColumn ||
            !this.avgDealSizeColumn ||
            !this.revenueColumn) {
            throw new Error('Values for all required Seller Performance parameters must be provided');
        }
        if (dataSource.columns) {
            if (!dataSource.columns.find((c) => c.name === this.sellerIdColumn)) {
                throw new Error(`Column ${this.sellerIdColumn} not in data source ${dataSource.dataSourceID}`);
            }
        }
        const params = new Map();
        params.set(SellerPerformanceParamNames.DataSourceID, dataSource.dataSourceID);
        params.set(SellerPerformanceParamNames.SellerIdColumn, this.sellerIdColumn);
        params.set(SellerPerformanceParamNames.SellerNameColumn, this.sellerNameColumn);
        params.set(SellerPerformanceParamNames.AttainmentColumn, this.attainmentColumn);
        params.set(SellerPerformanceParamNames.AvgDealSizeColumn, this.avgDealSizeColumn);
        params.set(SellerPerformanceParamNames.RevenueColumn, this.revenueColumn);
        if (this.variablePayRatioColumn) {
            params.set(SellerPerformanceParamNames.VariablePayRatioColumn, this.variablePayRatioColumn);
        }
        if (this.winRateColumn) {
            params.set(SellerPerformanceParamNames.WinRateColumn, this.winRateColumn);
        }
        return params;
    }
    get allParams() {
        return [
            SellerPerformanceParamNames.SellerIdColumn,
            SellerPerformanceParamNames.SellerNameColumn,
            SellerPerformanceParamNames.AttainmentColumn,
            SellerPerformanceParamNames.AvgDealSizeColumn,
            SellerPerformanceParamNames.WinRateColumn,
            SellerPerformanceParamNames.RevenueColumn,
            SellerPerformanceParamNames.VariablePayRatioColumn
        ];
    }
    get optionalParams() {
        return [SellerPerformanceParamNames.VariablePayRatioColumn, SellerPerformanceParamNames.WinRateColumn];
    }
    get size() {
        return SellerPerformanceParams_1.size();
    }
    static size() {
        return 7;
    }
};
SellerPerformanceParams = SellerPerformanceParams_1 = __decorate([
    JsonSchemaV2(sellerPerformanceParamsSchema, sellerPerformanceParamsSchemaValidation),
    JsonDiscriminatorValue(SolutionType.SellerPerformance)
], SellerPerformanceParams);
export { SellerPerformanceParams };
//# sourceMappingURL=sellerPerformanceParams.js.map